// GIGWORK-routed orders carry the placeholder pic 'GIGWORK'; append the claimed gig worker's name when known.
export const formatPicLabel = (order: { pic?: string; gigWorker?: string }): string => {
  if (order.pic === 'GIGWORK' && order.gigWorker) {
    return `GIGWORK(${order.gigWorker})`;
  }
  return order.pic || '-';
};
